import { getCalculatePercentileAction } from './shared';
import type { CreateApplicationStageConfig } from './types';

export const createAppliedStageConfig: CreateApplicationStageConfig = actions => ({
  badge: { id: 'applied', label: 'Applied', color: 'info' },
  getAttributes: application => [{ id: 'pool', value: application.pool.name ?? '' }],
  getActions: () => [getCalculatePercentileAction(actions)],
  getActiveProcessesProps: () => ({
    collapsible: false,
    items: [
      {
        id: 'review-application',
        title: 'Review application',
        action: { id: 'make-decision', label: 'Make decision', variant: 'contained', onClick: actions.makeDecision },
      },
    ],
  }),
});
